@if (isVisible() && config) {
  <div class="notice">
    <i class="fa-regular {{ config.icon }} icon"></i>
    <div class="notice-content">
      @if (config.title) {
        <div class="notice-title">{{ config.title }}</div>
      }
      <p class="notice-message">{{ config.message }}</p>
      @if (config.hyperlink && sanitizedLink) {
        <a class="notice-link" [routerLink]="sanitizedLink">{{ config.hyperlink.text }}</a>
      }
    </div>
  </div>
}
